export default __webpack_public_path__ + "static/media/dry_cool.7927d99b.mp4";